import {StyledDashboardCard} from './style'
import {Text} from '@/components/ui/text/Text'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const AccessesTableDashboardEmptyState = ({title, isLoading}: {title: string; isLoading: boolean}) => {
    return (
        <StyledDashboardCard>
            <Text size="textSm" palette="neutral" shade="600">
                {title}
            </Text>
            {isLoading ? (
                <Skeleton width="160px" height="28px" />
            ) : (
                <Text size="textXl" palette="neutral" shade="950" weight="500">
                    -
                </Text>
            )}
        </StyledDashboardCard>
    )
}
